import Swiper from 'swiper'

const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

if(homeSlideshow){
    let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        fadeEffect: {
            crossFade: true
        },

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        // Navigation (arrow)
        navigation: {
            nextEl: `.swiper-button-next`,
            prevEl: `.swiper-button-prev`,
        },

        // Pagination (bullet)
        pagination: {
            el: '.slideshow__pagination',
            type: 'bullets',
            clickable: true
        }
    }

    if(dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if(nbSlides > 1) {
        let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
    }
}

// Slider Posts
let postsSlides = document.querySelectorAll('.post .swiper-container .swiper-slide').length;

let postsConfig = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        loop : false,
        slidesPerView: 'auto',

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

        // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,    

    navigation: {
        nextEl: `.post__navigation .swiper-button-next`,
        prevEl: `.post__navigation .swiper-button-prev`,
    },
}

if(postsSlides > 1) {
    let swiperPosts = new Swiper('.post .swiper-container', postsConfig);
}


// Slider Events
let eventsSlides = document.querySelectorAll('.events .swiper-container .swiper-slide').length;

let eventsConfig = {
        effect : 'slide',
        grabCursor : 'true',
        speed: 700,
        loop : true,
        slidesPerView: 'auto',

    fadeEffect: {
        crossFade: true
    },

    keyboard: {
        enabled: true,
    },

    mousewheel: {
        forceToAxis: true,
        releaseOnEdges : true,
    },

        // Default parameters
    slidesPerView: 1,
    spaceBetween: 0,    

    navigation: {
        nextEl: `.events__navigation .swiper-button-next`,
        prevEl: `.events__navigation .swiper-button-prev`,
    },
}

if(eventsSlides > 2) {
    let swiperEvents = new Swiper('.events .swiper-container', eventsConfig);
}